import { render, staticRenderFns } from "./CashBasicGridDimensionWrapper.vue?vue&type=template&id=77a58dc0&scoped=true&"
import script from "./CashBasicGridDimensionWrapper.vue?vue&type=script&lang=ts&"
export * from "./CashBasicGridDimensionWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./CashBasicGridDimensionWrapper.vue?vue&type=style&index=0&id=77a58dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a58dc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
